/** @jsxRuntime classic */

/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import { ErrorMessage as BaseErrorMessage } from 'formik';
import { useFormTheme } from '.';
import { Text } from '@bottlebooks/gatsby-design-system';
export default function ErrorMessage(props) {
  var theme = useFormTheme();
  return jsx(BaseErrorMessage, Object.assign({
    component: Text,
    // @ts-ignore Additional types are passed through.
    variant: "smallest",
    sx: Object.assign({
      color: 'brand.warningRed'
    }, theme === null || theme === void 0 ? void 0 : theme.error)
  }, props));
}